import React, { CSSProperties, useRef } from 'react';

import { useConnectorDrag } from './useConnectorDrag';
import { useConnectorRegister } from './useConnectorRegister';

import { Connector, ConnectorProps } from './Connector';

import { connectorTypesMap } from './connectorTypes';

export type ExecutionState = { type: string; [key: string]: any };

export interface ConnectorFalseProps extends ConnectorProps {
  nodeId: string;
  cardRootRef: React.RefObject<HTMLElement>;
  activeConnectors: Set<string>;
  executionState: ExecutionState;
  positionStyle?: CSSProperties;
  isHovered?: boolean;
  isSelected?: boolean;
  isDisabled?: boolean;
  isDisabledStyle?: string;
  isVisibleOverride?: boolean;
  isDragOverAndCanConnect?: boolean;
}

export function ConnectorFalse(props: ConnectorFalseProps) {
  const circleRef = useRef<SVGCircleElement | null>(null);
  const connectorFalseRef = useRef<HTMLDivElement | null>(null);

  const collectedProps = useConnectorDrag({
    ref: connectorFalseRef,
    type: connectorTypesMap.False,
    nodeId: props.nodeId,
    isDisabled: props.isDisabled,
  });

  useConnectorRegister({
    cardRootRef: props.cardRootRef,
    centerRef: circleRef,
    type: connectorTypesMap.False,
    nodeId: props.nodeId,
    centerRefs: null,
  });

  const isActive = props.activeConnectors.has(`${props.nodeId}::${connectorTypesMap.False}`);
  const isSiblingActive = props.activeConnectors.has(`${props.nodeId}::${connectorTypesMap.True}`);

  return (
    <Connector
      circleRef={circleRef}
      dragHandleRef={connectorFalseRef}
      positionStyle={props.positionStyle}
      connectorType={connectorTypesMap.False}
      executionState={props.executionState}
      isActive={isActive}
      isSiblingActive={isSiblingActive}
      isHovered={props.isHovered}
      isSelected={props.isSelected}
      isDisabled={props.isDisabled}
      isDisabledStyle={props.isDisabledStyle}
      isDragging={collectedProps?.isDragging}
      isVisibleOverride={props.isVisibleOverride}
      isDragOverAndCanConnect={props.isDragOverAndCanConnect}
      direction={props.direction}
      positionYOffset={props.positionYOffset}
    />
  );
}
